import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useNavigate, useParams } from 'react-router-dom'
import ColumnHeading from '../../MyExperiment/components/columnHeading'

import { URLS } from '../../../_config'
import parse from 'html-react-parser'
import AOS from 'aos'
import Icon from '../../../components/icons'
import { usePreExistingTemplateApi } from '../../../store/api/hooks/preExistingTemplateApiHook'
import { useFpLoader } from '../../../store/api/hooks/fpLoaderHook'
import moment from 'moment'
import TemplateCard from './TemplateCard'
import NoResultFound from './NoResultFound'
import { startTiming, stopTiming } from '../../../utils/analytics/rumTracking'
import { trackEvent } from '../../../_common/functions'

interface PreExistingTemplateListProps {
    templates: any[]
}

const PreExistingTemplatesList: React.FC<PreExistingTemplateListProps> = ({ templates }) => {
    const { t } = useTranslation()
    const params: any = useParams()
    console.log('Received params:', params) // Debugging line to check received params
    const preExistingTemplateDetails = usePreExistingTemplateApi()
    const { showLoader, hideLoader } = useFpLoader()
    const navigate: any = useNavigate()
    const [searchTerm, setSearchTerm] = useState('')
    const [deyailsTemplates, setDeyailsTemplates] = React.useState<any[]>([])

    useEffect(() => {
        AOS.init({
            once: false, // Animation occurs every time you scroll to the element
        })
        AOS.refresh()
    }, [])
    const handleBackClick = () => {
        trackEvent('template_no_result_back_clicked', { source: 'list' })
        console.log('Back button clicked') // Debugging line to check if the function is triggered
    }
    const getTemplateDetails = () => {
        const payload: any = {
            search: searchTerm,
        }
        setDeyailsTemplates([])
        showLoader()
        startTiming('template_search')
        preExistingTemplateDetails.getTemplate(
            payload,
            (response: any) => {
                hideLoader()
                stopTiming('template_search', { search_term: searchTerm, result_count: response?.data?.result?.length })
                const resultCount = response?.data?.result?.length ?? 0
                trackEvent('template_search_results_loaded', { search_term: searchTerm, result_count: resultCount })
                if (resultCount === 0) {
                    trackEvent('template_no_result_shown', { search_term: searchTerm, source: 'list' })
                }
                setDeyailsTemplates(
                    response.data.result?.map((template: any) => {
                        const updatedKpi = {
                            ...template.kpi,
                            literral_value: template.kpi?.name || t('Not Applicable'),
                        }
                        const { hypothesis, ...restTemplate } = template
                        const { problem_statement, ...restTemplateWithoutProblemStatement } = restTemplate
                        return {
                            ...restTemplateWithoutProblemStatement,
                            hypothesisPlaceholder: hypothesis || '',
                            problem_statementPlaceholder: problem_statement || '',

                            id: template.template_literal,
                            experiment_name: template?.country?.title + '_' + template?.business_function?.title + '_',
                            name: template.title,
                            lastUpdated: template.updated_at ? moment(template.updated_at).format('MM DD YYYY') : '',
                            owner: t('DS Team'),
                            kpi: updatedKpi,
                            experiment_metadatas: {
                                ...template.experiment_metadatas,
                                metrices: [updatedKpi, ...(template.experiment_metadatas?.metrices || [])],
                            },

                            topFields: [
                                {
                                    label: t('Hypothesis'),
                                    value: template.hypothesis,
                                },
                                {
                                    label: t('KPI'),
                                    value: template.kpi?.name || t('Not Applicable'),
                                },
                                {
                                    label: t('MDE and Confidence'),
                                    value: `${template.mde}% & ${template.confidence}%`,
                                },
                                {
                                    label: t('Problem Statement'),
                                    value: template.problem_statement,
                                },
                            ],

                            bottomFields: [
                                {
                                    label: t('Country'),
                                    value: template?.country?.title || t('Not Applicable'),
                                },
                                {
                                    label: t('Experiment type'),
                                    value: template?.experiment_type?.title || t('Not Applicable'),
                                },
                                {
                                    label: t('Business Domain'),
                                    value: template?.business_function?.title || t('Not Applicable'),
                                },
                                {
                                    label: t('Use Case'),
                                    value: template?.use_case?.title || t('Not Applicable'),
                                },
                            ],
                        }
                    }),
                )
            },
            (error: any) => {
                hideLoader()
                trackEvent('template_search_results_failed', { search_term: searchTerm, error_message: error?.message })
                console.error('Error fetching template details:', error)
            },
        )
    }
    useEffect(() => {
        if (searchTerm) {
            trackEvent('template_keyword_searched', { search_term: searchTerm })
            getTemplateDetails()
        }
    }, [searchTerm])

    return (
        <div className="py-[0.667rem] bg-white" data-aos="zoom-in" data-aos-delay="200">
            <div className="mx-[0.667rem] flex flex-col gap-[0.667rem]">
                <div className="py-4 flex flex-col">
                    <div className="flex-grow flex items-center justify-center">
                        <div className=" bg-white rounded-[0.833rem] py-[1.5rem] px-[1.25rem]  shadow-1 w-[62.208rem]">
                            <div className="flex items-center justify-between -ml-[0.5rem]">
                                <ColumnHeading>{t('Pre Existing Template')}</ColumnHeading>
                                <div>
                                    <div className="flex items-center border rounded-[0.417rem]  shadow-sm bg-white h-[1.709rem] min-w-[13.150rem] max-w-[13.150rem]">
                                        <input type="text" placeholder={t('Search by keyword')} value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="w-full text-[0.667rem]  outline-none bg-transparent px-2 cursor-text" />
                                        {searchTerm && (
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    trackEvent('template_search_cleared', {})
                                                    setSearchTerm('')
                                                }}
                                                className="text-slate-600 hover:text-slate-800 w-[1.709rem] h-full flex items-center justify-center transition-colors"
                                            >
                                                <Icon name="close" size={'0.667rem'} />
                                            </button>
                                        )}
                                        <button type="button" className="text-slate-800 w-[1.709rem] h-full flex items-center justify-center">
                                            <Icon name="search" size={0.833} />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className={`${searchTerm === '' ? 'grid grid-cols-3' : ' '} content-stretch  gap-[1.333rem] items-start relative shrink-0  w-full py-6`}>
                                {searchTerm === '' ? (
                                    templates.map((template: any) => (
                                        <button
                                            type="button"
                                            onClick={() => {
                                                trackEvent('template_domain_card_clicked', { domain_id: template.id, domain_name: template.name, source: 'list' })
                                                navigate(URLS.PREEXISTING_TEMPLATE_LIST(template.id))
                                            }}
                                            key={template.id}
                                            className="bg-[#f5e003] flex-[1_0_0]  min-h-px min-w-px relative rounded-[8px] cursor-pointer hover:shadow-lg transition-shadow  h-[8.113rem] flex items-center justify-center"
                                        >
                                            <div className="flex flex-col items-center justify-center overflow-clip rounded-[inherit] size-full">
                                                <div className="content-stretch flex flex-col gap-[0rem] items-center justify-center px-[1.333rem] py-[1.042rem] relative w-full h-[8.113rem]">
                                                    <div className="absolute top-0 left-0 w-full h-full z-10 flex flex-col justify-center items-center">
                                                        <div className="content-stretch flex flex-col gap-[0.167rem] items-center justify-center relative shrink-0 text-black text-[3rem] mb-2 template-icon">{parse(template?.iconUrl || '')}</div>

                                                        <div className="content-stretch flex flex-col items-center justify-center leading-[0] not-italic relative shrink-0 w-full whitespace-nowrap">
                                                            <div className="flex flex-col font-['Poppins:Medium',sans-serif] justify-center relative shrink-0 text-[#0d121c] text-[28px]">
                                                                <p className="leading-[1rem] text-[1.167rem] font-medium">{template.name}</p>
                                                            </div>
                                                            <div className="flex flex-col font-['Poppins:Regular',sans-serif] justify-center relative shrink-0 text-[#4b5565] text-[16px]">
                                                                <p className="leading-[1rem] text-[0.667rem]">{template.description}</p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="absolute left-[-104.5px] size-[267px] top-[14px] z-0">
                                                        <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 267 267" aria-hidden="true">
                                                            <path
                                                                d="M267 133.5C267 207.23 207.23 267 133.5 267C59.77 267 0 207.23 0 133.5C0 59.77 59.77 0 133.5 0C207.23 0 267 59.77 267 133.5ZM48.1473 133.5C48.1473 180.639 86.361 218.853 133.5 218.853C180.639 218.853 218.853 180.639 218.853 133.5C218.853 86.361 180.639 48.1473 133.5 48.1473C86.361 48.1473 48.1473 86.361 48.1473 133.5Z"
                                                                fill="#E5B611"
                                                                fillOpacity="0.4"
                                                            />
                                                        </svg>
                                                    </div>
                                                </div>
                                            </div>
                                        </button>
                                    ))
                                ) : (
                                    <>
                                        {deyailsTemplates.map((template) => (
                                            <div key={template.id} className="flex flex-col gap-[20px] py-2">
                                                <TemplateCard
                                                    template={template}
                                                    key={template.id}
                                                    name={template.name}
                                                    lastUpdated={template.lastUpdated}
                                                    owner={template.owner}
                                                    topFields={template.topFields}
                                                    bottomFields={template.bottomFields}
                                                    source="search"
                                                />
                                            </div>
                                        ))}
                                        {deyailsTemplates.length === 0 && searchTerm !== '' && (
                                            <div className="min-h-screen flex items-center justify-center bg-white p-8">
                                                <NoResultFound onBackClick={handleBackClick} title={t('No Result Found')} description={t('Please search with proper keyword to view more template')} buttonText={t('Back to List')} />
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PreExistingTemplatesList
